module.exports = __webpack_public_path__ + "static/media/box.d7aad6da.svg";